/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_B3_DescInputs */

const en_simple_oto_b3_desc = /** @type {(inputs: Simple_Oto_B3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every stage ends with a link you can open and share. Happy with it, continue. Not yet, ask for a change.`)
};

const id_simple_oto_b3_desc = /** @type {(inputs: Simple_Oto_B3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiap tahap berakhir dengan tautan yang bisa kamu buka dan bagikan. Cocok, lanjut. Belum cocok, minta ubah.`)
};

/**
* | output |
* | --- |
* | "Every stage ends with a link you can open and share. Happy with it, continue. Not yet, ask for a change." |
*
* @param {Simple_Oto_B3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_b3_desc = /** @type {((inputs?: Simple_Oto_B3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_B3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_b3_desc(inputs)
	return en_simple_oto_b3_desc(inputs)
});